import axios from 'axios';
import BaseAPI from './base/base-api';

class authAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'auth';

}

export default new authAPI();